import { Box, Typography } from "@mui/material";
import { ReactComponent as DoubleUpIcon } from "../../assets/icons/double-up-arrow.svg";
import { ReactComponent as DoubleDownIcon } from "../../assets/icons/double-down-arrow.svg";

function GrowthBadge({ sx = [], ...props }) {
  const { rate } = props;
  const isNegative = rate <= 0;
  return (
    <Box
      sx={[
        {
          minWidth: 70,
          px: "8px",
          py: "2px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: isNegative ? "red.light" : "primary.light",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        variant="subtitle1"
        color={isNegative ? "red.main" : "primary.main"}
      >
        {`%${Math.abs(rate)}`}
      </Typography>
      <Box ml={"4px"} sx={{ display: "flex", alignItems: "center" }}>
        {isNegative ? (
          <DoubleDownIcon width={8} height={10} />
        ) : (
          <DoubleUpIcon width={8} height={10} />
        )}
      </Box>
    </Box>
  );
}

export default GrowthBadge;
